import { StateCreator } from "zustand";
import {
  AuthUser,
  AuthSlice,
  MessageSlice,
  ThemeSlice,
  RegisterSlice,
  SectionSlice,
  OptionSlice,
  OrganizationSlice,
} from "../../interfaces";

export const createAuthSlice: StateCreator<
  RegisterSlice &
    SectionSlice &
    MessageSlice &
    AuthSlice &
    OptionSlice &
    OrganizationSlice &
    ThemeSlice,
  [["zustand/persist", unknown]],
  [],
  AuthSlice & MessageSlice
> = (set: any, get: any) => {
  return {
    userInfoZustand: null,
    authUserZustand: null,

    setAuthUserZustand: (data: { userInfo: any; authUser: AuthUser }) => {
      set({
        userInfoZustand: data.userInfo,
        authUserZustand: data.authUser,
      });
    },

    removeAuthUserZustand: () => {
      set({
        userInfoZustand: null,
        authUserZustand: null,
      });
    },

    messageZustand: "",
    messageTypeZustand: "",
    linkZustand: null,
    setMessageZustand(message, messageType) {
      set({
        messageZustand: message,
        messageTypeZustand: messageType,
      });
    },
    removeMessageZustand() {
      set({
        messageZustand: null,
        messageTypeZustand: null,
        linkZustand: null,
      });
    },
    updateToken: (newToken: string) => {
      const currentAuth = get().authUserZustand;
      if (currentAuth) {
        set({
          authUserZustand: { ...currentAuth, Token: newToken },
        });
      }
    },
  };
};
